import { useMemo } from "react";
import { captureException } from "../../../exceptions";
import useGetFartherManagedAccounts from "../../Accounts/hooks/useGetFartherManagedAccounts";
import useGetAccountGroupsPerformancesV4 from "./useGetAccountGroupsPerformancesV4";
import useGetAccountGroupsV4 from "./useGetAccountGroupsV4";
export default function useAllAccountBalancesV4(clientId, doNotIncludeSharedAccounts, auth) {
    const accountGroupsReqBody = {
        dateRanges: null,
        feeMethod: "grossOfFees",
        returnMethod: "cumulative",
    };
    const accountGroups = useGetAccountGroupsV4(auth);
    const accounts = useGetFartherManagedAccounts(clientId, auth);
    const accountGroupsPerformances = useGetAccountGroupsPerformancesV4(clientId, accountGroupsReqBody, auth);
    return useMemo(() => {
        if (accountGroups.isLoading || accountGroups.hasError) {
            return accountGroups;
        }
        if (accounts.isLoading || accounts.hasError) {
            return accounts;
        }
        if (accountGroupsPerformances.isLoading ||
            accountGroupsPerformances.hasError) {
            return accountGroupsPerformances;
        }
        const singleAccountGroups = accountGroups.data.filter((ag) => ag.accountGroupType === "SINGLE_CLIENT_ACCOUNT");
        const filteredGroups = singleAccountGroups.filter((ag) => doNotIncludeSharedAccounts
            ? accounts.data.find((a) => a.virtualAccountId === ag.virtualAccountIds[0])?.sharedBy.length === 0
            : true);
        const filteredPerformanceGroups = accountGroupsPerformances.data.filter((pg) => filteredGroups.some((ag) => ag.accountGroupId === pg.accountGroupId));
        return {
            isLoading: false,
            hasError: false,
            data: filteredPerformanceGroups.reduce((accum, curr) => {
                const group = filteredGroups.find((ag) => ag.accountGroupId === curr.accountGroupId);
                if (group === undefined) {
                    const error = new Error("Account group performance does not exist in list of account groups");
                    captureException(error, "useAllAccountBalancesV4.ts", {
                        extra: {
                            file: "useAllAccountBalancesV4.ts",
                            ClientId: clientId,
                            accountGroupId: curr.accountGroupId,
                        },
                    });
                    throw error;
                }
                const accountId = group.virtualAccountIds[0];
                if (accountId === undefined) {
                    const error = new Error("virtualAccountIds is empty (group.virtualAccountIds[0] === undefined) in account group");
                    captureException(error, "useAllAccountBalancesV4.ts", {
                        extra: {
                            file: "useAllAccountBalancesV4.ts",
                            ClientId: clientId,
                            accountGroupId: curr.accountGroupId,
                        },
                    });
                    throw error;
                }
                return [
                    ...accum,
                    {
                        accountId,
                        balance: curr.balanceSummary?.[0]?.balance ?? null,
                    },
                ];
            }, []),
        };
    }, [
        accountGroups,
        accounts,
        accountGroupsPerformances,
        clientId,
        doNotIncludeSharedAccounts,
    ]);
}
//# sourceMappingURL=useAllAccountBalancesV4.js.map